import type { PublicState } from '../../shared/protocol';
import { formatCountdown } from '../util/format';
import { useServerClock } from '../util/clock';

/** Hider-only boundary/hiding-zone penalty warning (§8). Present only in the
 *  hider's snapshot, so the seeker never learns location by inference. */
export function PenaltyWarning({ state }: { state: PublicState }) {
  const now = useServerClock(state.timer.serverNow, [state.penalty?.graceEndsAt]);
  const p = state.penalty;
  if (!p || p.status === 'none') return null;
  const where = p.region === 'boundary' ? 'the play area' : 'your hiding zone';

  if (p.status === 'grace') {
    const left = Math.max(0, (p.graceEndsAt ?? now()) - now());
    return (
      <div className="penalty penalty--grace" data-testid="penalty">
        <span className="penalty__title">Outside {where}</span>
        <span className="penalty__body">
          Return in <span className="t">{formatCountdown(left)}</span> or you will be penalized.
        </span>
      </div>
    );
  }
  return (
    <div className="penalty penalty--accruing" data-testid="penalty">
      <span className="penalty__title">Penalty −{Math.round(p.accruedMin)}m</span>
      <span className="penalty__body">Get back inside {where}</span>
    </div>
  );
}
